//window._ = require('lodash');
//window.parallaxScroll = require('parallax-scroll');

//import Parallax  from 'parallax-js';
//import AOS from 'aos';
//import 'aos/dist/aos.css'; // You can also use <link> for styles
//AOS.init();

// missing forEach on NodeList for IE11
//if (window.NodeList && !NodeList.prototype.forEach) {
//    NodeList.prototype.forEach = Array.prototype.forEach;
//}

// Parallax
//const depthFactor = 5; // Depth of the image wrt to the 0 z-index. Infinity being at the same distance as the rest of the content and 1 being as far away as possible.

//const resizeParallax = () => {
//    var parallaxes = document.querySelectorAll('.parallax');
//    var parallaxesArray = Array.prototype.slice.call(parallaxes);
//
//    parallaxesArray.forEach(parallax => {
//        let height = 0; // To take into account absolute elements;
//
//        var layers = parallax.querySelectorAll('.parallax-layer');
//        var layersArray = Array.prototype.slice.call(layers);
//
//        layersArray.forEach(layer => {
//            const changeHeight = () => {
//                height = Math.max(height, layer.clientHeight);
//
//                if (height > parallax.clientHeight) {
//                    parallax.style.height = `${height}px`; // The largest element's height
//                }
//            }
//
//            if (layer.clientHeight == 0 && layer.tagName == 'IMG') {
//                layer.addEventListener('load', changeHeight); // Images need to load first, then their size becomes determined.
//            } else {
//                changeHeight();
//            }
//        })
//    })
//}

//const getInitialHeights = () => {
//    var layers = document.querySelectorAll('.parallax-layer');
//    var layersArray = Array.prototype.slice.call(layers);
//
//    layersArray.forEach(layer => {
//        layer.setAttribute('data-initial-height', layer.getBoundingClientRect().top + window.pageYOffset)
//    })
//}

//const reposition = () => {
//    var parallaxes = document.querySelectorAll('.parallax');
//    var parallaxesArray = Array.prototype.slice.call(parallaxes);
//
//    parallaxesArray.forEach(parallax => {
//        var layers = parallax.querySelectorAll('.parallax-layer');
//        var layersArray = Array.prototype.slice.call(layers);
//
//        layersArray.forEach(layer => {
//            //console.log(parallax.offsetTop, window.scrollY, parallax.getBoundingClientRect().top);
//            //console.log(parallax.offsetTop, window.pageYOffset, parallax.getBoundingClientRect().top);
//            //console.log(window.scrollY - parallax.offsetTop);
//            //console.log(document.documentElement.clientHeight);
//
//            const depth = Number(layer.getAttribute('data-depth-factor') || depthFactor); // Dynamically get depthFactor
//            const initialLayerHeight = Number(layer.getAttribute('data-initial-height'));
//            let moveLayer = window.scrollY / depth; // The amount the layer should be moved by
//
//            //let fromTop = -1 * (parallax.getBoundingClientRect().top) + 50;
//            //let scrollFromParallaxTop = fromTop > 0 ? fromTop : 0
//            //console.log(fromTop);
//            //let moveLayer = (scrollFromParallaxTop) / depth; // The amount the layer should be moved by
//
//            if (initialLayerHeight > document.documentElement.clientHeight) {
//                moveLayer -= (initialLayerHeight - document.documentElement.clientHeight) / depth
//            };
//
//            //console.log(moveLayer);
//
//            const renderedLayerTop = layer.getBoundingClientRect().top + moveLayer;
//            const renderedLayerBottom = layer.getBoundingClientRect().bottom + moveLayer;
//
//            if (renderedLayerTop <= document.documentElement.clientHeight && renderedLayerBottom >= 0) { // Only translate if the final element will be on screen
//                layer.style.transform = `translateY(${moveLayer}px)`; // Move differently than the rest of the window
//            }
//        })
//    })
//
//    window.requestAnimationFrame(reposition);
//}

//window.addEventListener('DOMContentLoaded', () => {
//    resizeParallax();
//    getInitialHeights();
//    window.requestAnimationFrame(reposition);
//});
//
//window.addEventListener('resize', resizeParallax);








window.lettering = window.lettering || {};

(function () {

    var opts = {
        "chars": ["char", ""],
        "words": ["word", " "],
        "lines": ["line", "<br />"]
    };

    lettering.splitter = function (e, t) { // Element, type
        var type = opts[t || "chars"],
            splitBy = type[1],
            d = '',
            c = 0,
            arr, a, m;

        arr = e.childNodes;
        for (var i = 0, len = arr.length; i < len; i++) {
            if (arr[i].nodeType === 3 && type[0] === "line") {
                c++;
                m = c % 2;
                d += ["<span class='", type[0] + c, ((m !== 0) ? " even" : " odd"), "'>", arr[i].nodeValue, "</span>", splitBy].join("");
            } else if (arr[i].nodeType === 3 && type[0] !== "line") {
                a = arr[i].data.split(splitBy);

                for (var k = 0, len2 = a.length; k < len2; k++) {
                    c++;
                    m = c % 2;
                    d += ["<span class='", type[0] + c, ((m !== 0) ? " even" : " odd"), "'>", a[k], "</span>", splitBy].join("");
                }
            }
        }
        c = 0;

        e.innerHTML = d;
    };

})();


window.getAjax = function (url, success) {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    xhr.open('GET', url);
    xhr.onreadystatechange = function () {
        if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
    return xhr;
};




const links = document.querySelectorAll(".scroll");
const linksArray = Array.prototype.slice.call(links);
const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;


linksArray.forEach(link => {
    link.addEventListener("click", clickHandler);
})

//for (const link of links) {
//    link.addEventListener("click", clickHandler);
//}

function clickHandler(e) {
    //console.log(offsetTop);

    if (supportsNativeSmoothScroll) {
        e.preventDefault();
        const href = this.getAttribute("href");
        var offsetTop = document.querySelector(href).offsetTop;

        if ((offsetTop - 50) < 0) {
            offsetTop = 0;
        } else {
            offsetTop = offsetTop - 50;
        }

        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    } else {
        return;
    }


    //scroll({
    //    top: offsetTop,
    //    behavior: "smooth"
    //});
}



// smooth scroll
//(function () {
//    'use strict';
//
//    //if (window.NodeList && !NodeList.prototype.forEach) {
//    //    NodeList.prototype.forEach = Array.prototype.forEach;
//    //}
//
//    // Feature Test
//    if ('querySelector' in document && 'addEventListener' in window && Array.prototype.forEach) {
//        // Function to animate the scroll
//        var smoothScroll = function (anchor, duration) {
//            // Calculate how far and how fast to scroll
//            var startLocation = window.pageYOffset;
//            var endLocation = anchor.offsetTop;
//            var distance = endLocation - startLocation;
//            var increments = distance / (duration / 16);
//            var stopAnimation;
//            // Scroll the page by an increment, and check if it's time to stop
//            var animateScroll = function () {
//                window.scrollBy(0, increments);
//                stopAnimation();
//            };
//            // If scrolling down
//            if (increments >= 0) {
//                // Stop animation when you reach the anchor OR the bottom of the page
//                stopAnimation = function () {
//                    var travelled = window.pageYOffset;
//                    if ((travelled >= (endLocation - increments)) || ((window.innerHeight + travelled) >= document.body.offsetHeight)) {
//                        clearInterval(runAnimation);
//                    }
//                };
//            }
//            // Loop the animation function
//            var runAnimation = setInterval(animateScroll, 16);
//        };
//        // Define smooth scroll links
//        var scrollToggle = document.querySelectorAll('.scroll');
//        // For each smooth scroll link
//        [].forEach.call(scrollToggle, function (toggle) {
//            // When the smooth scroll link is clicked
//            toggle.addEventListener('click', function (e) {
//                // Prevent the default link behavior
//                e.preventDefault();
//                // Get anchor link and calculate distance from the top
//                var dataID = toggle.getAttribute('href');
//                var dataTarget = document.querySelector(dataID);
//                var dataSpeed = toggle.getAttribute('data-speed');
//                // If the anchor exists
//                if (dataTarget) {
//                    // Scroll to the anchor
//                    smoothScroll(dataTarget, dataSpeed || 500);
//                }
//            }, false);
//        });
//    }
//})();
